import { c as _c } from "react/compiler-runtime";
import Squares2X2Icon from "@/components/common/icons/Squares2X2Icon";
import { SidebarSection } from "@/components/navigation/navTypes";
import { AboutSection } from "@/enums";
import { DocumentTextIcon, UsersIcon, WrenchIcon } from "@heroicons/react/24/outline";
import { useMemo, type ComponentType } from "react";
export function useSidebarSections(appWalletsSupported, isIos, country) {
  const $ = _c(53);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      name: "Identities",
      href: "/network"
    }, {
      name: "Activity",
      href: "/network/activity"
    }, {
      name: "Groups",
      href: "/network/groups"
    }, {
      name: "NFT Activity",
      href: "/nft-activity"
    }, {
      name: "Memes Calendar",
      href: "/meme-calendar"
    }, {
      name: "TDH",
      href: "/network/tdh"
    }, {
      name: "xTDH",
      href: "/network/xtdh"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      key: "network",
      name: "Network",
      icon: UsersIcon,
      items: t0,
      subsections: [{
        name: "Metrics",
        items: [{
          name: "Definitions",
          href: "/network/definitions"
        }, {
          name: "Network Stats",
          href: "/network/stats"
        }, {
          name: "Levels",
          href: "/network/levels"
        }]
      }]
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "collections",
      name: "Collections",
      icon: Squares2X2Icon,
      items: [{
        name: "The Memes",
        href: "/the-memes"
      }, {
        name: "6529 Gradient",
        href: "/6529-gradient"
      }, {
        name: "NextGen",
        href: "/nextgen"
      }, {
        name: "Meme Lab",
        href: "/meme-lab"
      }, {
        name: "ReMemes",
        href: "/rememes"
      }, {
        name: "xTDH",
        href: "/xtdh"
      }],
      subsections: []
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      name: "NFT Delegation",
      items: [{
        name: "Delegation Center",
        href: "/delegation/delegation-center"
      }, {
        name: "Wallet Architecture",
        href: "/delegation/wallet-architecture"
      }, {
        name: "Delegation FAQs",
        href: "/delegation/delegation-faq"
      }, {
        name: "Consolidation Use Cases",
        href: "/delegation/consolidation-use-cases"
      }, {
        name: "Wallet Checker",
        href: "/delegation/wallet-checker"
      }]
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== country || $[6] !== isIos) {
    t5 = !isIos || country?.toUpperCase() === "US" ? [{
      name: "Memes Subscriptions",
      href: "/tools/subscriptions-report"
    }] : [];
    $[5] = country;
    $[6] = isIos;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      name: "Memes Accounting",
      href: "/meme-accounting"
    };
    t7 = {
      name: "Memes Gas",
      href: "/meme-gas"
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5) {
    t8 = {
      name: "The Memes Tools",
      items: [...t5, t6, t7]
    };
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== appWalletsSupported) {
    t9 = appWalletsSupported ? [{
      name: "App Wallets",
      href: "/tools/app-wallets"
    }] : [];
    $[12] = appWalletsSupported;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      name: "API",
      href: "/tools/api"
    };
    t11 = {
      name: "EMMA",
      href: "/emma"
    };
    t12 = {
      name: "Block Finder",
      href: "/tools/block-finder"
    };
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t9) {
    t13 = {
      name: "Other Tools",
      items: [...t9, t10, t11, t12]
    };
    $[17] = t9;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      name: "Open Data",
      href: "/open-data"
    };
    t15 = {
      name: "Network Metrics",
      href: "/open-data/network-metrics"
    };
    $[19] = t14;
    $[20] = t15;
  } else {
    t14 = $[19];
    t15 = $[20];
  }
  let t16;
  if ($[21] !== country || $[22] !== isIos) {
    t16 = !isIos || country?.toUpperCase() === "US" ? [{
      name: "Meme Subscriptions",
      href: "/open-data/meme-subscriptions"
    }] : [];
    $[21] = country;
    $[22] = isIos;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  let t18;
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      name: "Rememes",
      href: "/open-data/rememes"
    };
    t18 = {
      name: "Team",
      href: "/open-data/team"
    };
    t19 = {
      name: "Royalties",
      href: "/open-data/royalties"
    };
    $[24] = t17;
    $[25] = t18;
    $[26] = t19;
  } else {
    t17 = $[24];
    t18 = $[25];
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t16) {
    t20 = {
      name: "Open Data",
      items: [t14, t15, ...t16, t17, t18, t19]
    };
    $[27] = t16;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t13 || $[30] !== t20 || $[31] !== t8) {
    t21 = {
      key: "tools",
      name: "Tools",
      icon: WrenchIcon,
      items: t3,
      subsections: [t4, t8, t13, t20]
    };
    $[29] = t13;
    $[30] = t20;
    $[31] = t8;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = [{
      name: "GDRC1",
      href: `/about/${AboutSection.GDRC1}`
    }];
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      name: "The Memes",
      href: `/about/${AboutSection.MEMES}`
    };
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== country || $[36] !== isIos) {
    t24 = !isIos || country?.toUpperCase() === "US" ? [{
      name: "Subscriptions",
      href: `/about/${AboutSection.SUBSCRIPTIONS}`
    }] : [];
    $[35] = country;
    $[36] = isIos;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  let t26;
  let t27;
  let t28;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      name: "Minting",
      href: `/about/${AboutSection.MINTING}`
    };
    t26 = {
      name: "Nakamoto Threshold",
      href: `/about/${AboutSection.NAKAMOTO_THRESHOLD}`
    };
    t27 = {
      name: "Meme Lab",
      href: `/about/${AboutSection.MEME_LAB}`
    };
    t28 = {
      name: "Gradients",
      href: `/about/${AboutSection.GRADIENTS}`
    };
    $[38] = t25;
    $[39] = t26;
    $[40] = t27;
    $[41] = t28;
  } else {
    t25 = $[38];
    t26 = $[39];
    t27 = $[40];
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t24) {
    t29 = {
      name: "NFTs",
      items: [t23, ...t24, t25, t26, t27, t28]
    };
    $[42] = t24;
    $[43] = t29;
  } else {
    t29 = $[43];
  }
  let t30;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      name: "NFT Delegation",
      items: [{
        name: "About NFTD",
        href: `/about/${AboutSection.NFT_DELEGATION}`
      }, {
        name: "Primary Address",
        href: `/about/${AboutSection.PRIMARY_ADDRESS}`
      }]
    };
    $[44] = t30;
  } else {
    t30 = $[44];
  }
  let t31;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      name: "6529 Capital",
      items: [{
        name: "About 6529 Capital",
        href: "/capital"
      }, {
        name: "Company Portfolio",
        href: "/capital/company-portfolio"
      }, {
        name: "NFT Fund",
        href: "/capital/fund"
      }]
    };
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      name: "Support",
      items: [{
        name: "FAQ",
        href: `/about/${AboutSection.FAQ}`
      }, {
        name: "Apply",
        href: `/about/${AboutSection.APPLY}`
      }, {
        name: "Contact Us",
        href: `/about/${AboutSection.CONTACT_US}`
      }]
    };
    $[46] = t32;
  } else {
    t32 = $[46];
  }
  let t33;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      name: "Resources",
      items: [{
        name: "Data Decentralization",
        href: `/about/${AboutSection.DATA_DECENTR}`
      }, {
        name: "ENS",
        href: `/about/${AboutSection.ENS}`
      }, {
        name: "License",
        href: `/about/${AboutSection.LICENSE}`
      }, {
        name: "Release Notes",
        href: `/about/${AboutSection.RELEASE_NOTES}`
      }]
    };
    $[47] = t33;
  } else {
    t33 = $[47];
  }
  let t34;
  if ($[48] !== t29) {
    t34 = {
      key: "about",
      name: "About",
      icon: DocumentTextIcon,
      items: t22,
      subsections: [t29, t30, t31, t32, t33]
    };
    $[48] = t29;
    $[49] = t34;
  } else {
    t34 = $[49];
  }
  let t35;
  if ($[50] !== t21 || $[51] !== t34) {
    t35 = [t1, t2, t21, t34];
    $[50] = t21;
    $[51] = t34;
    $[52] = t35;
  } else {
    t35 = $[52];
  }
  return t35;
}
export function useSectionMap(sections) {
  const $ = _c(2);
  let t0;
  if ($[0] !== sections) {
    t0 = new Map(sections.map(_temp));
    $[0] = sections;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(section) {
  return [section.key, section];
}
export interface SidebarPageEntry {
  name: string;
  href: string;
  section: string;
  subsection?: string;
  icon?: ComponentType<{
    className?: string;
  }>;
}
export function mapSidebarSectionsToPages(sections: SidebarSection[]): SidebarPageEntry[] {
  return sections.flatMap(section => {
    const sectionIcon = section.icon;
    const sectionItems: SidebarPageEntry[] = section.items.map(item => ({
      name: item.name,
      href: item.href,
      section: section.name,
      icon: sectionIcon
    }));
    const subsectionItems = section.subsections?.flatMap(subsection => subsection.items.map(item => ({
      name: item.name,
      href: item.href,
      section: section.name,
      subsection: subsection.name,
      icon: sectionIcon
    }))) ?? [];
    return [...sectionItems, ...subsectionItems];
  });
}